// extracted by mini-css-extract-plugin
export default {"subtitle":"GuidelineNav_subtitle__3seEO","title":"GuidelineNav_title__Luy22","iconContainer":"GuidelineNav_iconContainer__LJKCR","header":"GuidelineNav_header__6GjP8"};